import gql from 'graphql-tag'

export const GET_STEP_TYPE_LIST = gql`
  query GetStepTypes {
    stepTypes {
      id
      name
    }
  }
`

export const GET_STEP_TYPE_BY_ID = gql`
  query GetStepTypeById($id: Int!) {
    stepType(id: $id) {
      id
      name
    }
  }
`
